// extracted by mini-css-extract-plugin
module.exports = {"root":"_10530f","elevation-1":"_bf12ba","elevation-2":"_861cc7","elevation-16":"_b569d0","square":"_7e75e3"};